import { render } from "./user-order-check.vue?vue&type=template&id=5541ea1e&scoped=true"
import script from "./user-order-check.vue?vue&type=script&lang=js"
export * from "./user-order-check.vue?vue&type=script&lang=js"

import "./user-order-check.vue?vue&type=style&index=0&id=5541ea1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5541ea1e"]])

export default __exports__